import { PropType, CSSProperties, defineComponent } from 'vue';
import styles from './index.module.scss';
const props = {
  style: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
  leftStyle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
  rightStyle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
};
const LineTag = defineComponent({
  setup: (props) => {
    return () => (
      <div class={styles.LineTag} style={props.style}>
        <div class={styles.tagLeft} style={props.leftStyle} />
        <div class={styles.tagRight} style={props.rightStyle} />
      </div>
    );
  },
  props,
});
export default LineTag;
